'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils_paramError = require('./param-error.js');
var _forOwn = require('lodash/forOwn');
require('@babel/runtime/helpers/inheritsLoose');
require('@babel/runtime/helpers/wrapNativeSuper');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _forOwn__default = /*#__PURE__*/_interopDefaultLegacy(_forOwn);

var doesParamExist = function doesParamExist(params, hyperMediaEndpoint, opts) {
  if (opts === void 0) {
    opts = {
      atLeastOneExists: false
    };
  }

  var valueExists = false;

  if (hyperMediaEndpoint) {
    return null;
  }

  _forOwn__default["default"](params, function (val, key) {
    if (!val && !opts.atLeastOneExists) {
      throw new utils_paramError["default"](key);
    }

    if (val && opts.atLeastOneExists) {
      valueExists = true;
    }
  });

  if (!valueExists && opts.atLeastOneExists) {
    throw new utils_paramError["default"](Object.keys(params).join(' or '));
  }

  return null;
};

exports["default"] = doesParamExist;
